import { enStatus, ICourse } from './course';
import { IUpsell } from './upsell';
import { ISchool } from './school';

export interface IShelf {
  id?: number;
  title: string;
  count: number;
  url?: string;

  courses?: ICourse[];
  lessons?: any[];
  offers?: IUpsell[];
  schools?: ISchool[];
  type?: enShelfType;
}

export enum enShelfType {
  offer = 'offer',
  category = 'category',
  school = 'school',
  shelf = 'shelf',
}

export interface IShowcaseCourse {
  id: number;
  title: string;
  slug: string;
  published: number;
  hash: string;
  progress_bar: number;
  progress_percent?: number;
  total_lessons: number;
  share: string;
  like: boolean;
  new_content: boolean;
  status: enStatus;
  image: string;
  old_image: string;
  release_at: Date;
  expire_at: Date;
  lesson_id?: number;
}

export interface IShowcaseSchool {
  image: string;
  old_image: string;
  subdomain: string;
  domain: string;
  title: string;
  producer_id: number;
  id: number;
}
